import { SectionProps } from '../types';
import { StyledPipaSection } from './style';

export const PipaSection: React.FC<SectionProps> = ({ sectionName }) => (
  <StyledPipaSection>{sectionName}</StyledPipaSection>
);
